import { auto } from "../enums.js";
export default (function (placement) {
  return placement.split('-')[1];
});